import videoPlayerModal from "./videoModal";

export function videoModal(Alpine) {
    Alpine.data("videoPlayerModal", videoPlayerModal);
}
